import AppButton from "../common/AppButton"
import Input from "../common/input/Input"
import { useFormik } from "formik"
import { newsLetterSchema } from "../../utils/formikFormValidators"
import { toast } from "react-toastify"
import { getNonUserEmail } from "../../services/actions/authentication.actions"
import { alertError } from "../../utils/helperFunctions"

const NewsLetterForm = ({ onClose, isLoading, setIsLoading }) => {
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
    },
    validationSchema: newsLetterSchema,
    onSubmit: async (values) => {
      handleSubmit(values)
    },
  })

  const handleSubmit = async (values) => {
    setIsLoading(true)

    try {
      const response = await getNonUserEmail(values?.name, values?.email)
      if (response) {
        setIsLoading(false)
        onClose(true)
        toast.success("Thank you for subscribing!")
      }
    } catch (error) {
      alertError(error?.message)
      setIsLoading(false)
    }
  }

  return (
    <div>
      <form onSubmit={formik.handleSubmit} className="flex flex-col gap-[25px]">
        <Input
          label="Name"
          placeholder="Enter your name"
          value={formik.values.name}
          name="name"
          id="name"
          type="name"
          required
          onChange={formik.handleChange}
          error={formik.touched.name && formik.errors.name}
        />

        <Input
          label="Email"
          id="email"
          value={formik.values.email}
          name="email"
          required
          placeholder="Enter your email"
          onChange={formik.handleChange}
          error={formik.touched.email && formik.errors.email}
        />

        <AppButton className="rounded !w-full flex-none !h-[55px]" gradient type="submit">
          {isLoading ? "Subscribing ..." : "Subscribe"}
        </AppButton>
      </form>
    </div>
  )
}

export default NewsLetterForm
